// extracted by mini-css-extract-plugin
export default {"container":"ModelParameters-module__container--Hmn9u"};